import { LayaEnv } from "../../LayaEnv";
const PlatformAdapterNames = ["browser", "fs", "storage", "font", "textInput", "media", "device"];
;
export class PAL {
    static __init__() {
        for (let key of PlatformAdapterNames) {
            let cls = PAL._classes[key];
            if (cls)
                PAL[key] = new cls();
        }
    }
    static register(name, cls) {
        if (LayaEnv.isPlaying)
            PAL._classes[name] = cls;
    }
    static warnIncompatibility(name) {
        if (!warned.has(name)) {
            warned.add(name);
            console.warn(`${name} is not supported in this platform.`);
        }
    }
    static hasAPI(arg0, arg1) {
        let g = arg1 ? (arg0 || PAL.g) : PAL.g;
        let name = arg1 || arg0;
        if (g.willGenerateUndefinedAPIs)
            return Object.getOwnPropertyDescriptor(g, name) != null;
        else
            return g[name] != null;
    }
}
PAL.g = null;
PAL._classes = {};
const warned = new Set();
